import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useCredential, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { CredentialSchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import CredentialOldFormDumb from './CredentialOldFormDumb';


const CredentialEditOldSmart = (props) => {
  const { match: { params } } = props;
  const { credentialId } = params;
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, error, success, putCredential, getCredential, data, isLoaded } = useCredential();

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    description: '',
    project: projects[0].value,
    credentials: ''
  });

  useEffect(() => {
    if (!!success.put) {
      history.push(ROUTES.CREDENTIAL_LIST);
    } else if (!!success.get) {
      handleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.put, success.get]);

  useLayoutEffect(() => {
    const query = { credentialId }
    getCredential({ query });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    const credential = new CredentialSchema();
    credential.setValues(data);
    credential.values.fromEdit = true;
    credential.values.credentials_id = Number(credentialId);
    putCredential({ body: credential.getValues() });
  };


  function handleData() {
    const {name, description, project_id, txtCred} = data[0]
    const dataToEdit = {
      name,
      description,
      project: project_id,
      credentials: txtCred
    }
    setDefaultValues(dataToEdit);
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
        (
          <Backdrop
            invisible
            sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
            open={true}
          >
            <CircularProgress color="primary" />
          </Backdrop>
        ): (data && projects) ?
        (
          <CredentialOldFormDumb
            defaultValues={defaultValues}
            handleOnSubmit={handleEdit}
            isEdit={true}
          />
        )
        :(
          <ErrorScreen />
        )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(CredentialEditOldSmart));
